import Markdown from 'react-markdown';

import { useMemo } from 'react';
// import { useAuth } from '@/shared/context/AuthProvider';
import { Stack, Typography } from '@mui/material';
import WorkflowsProvider from './WorkflowsProvider';
// import { TaskWidget } from './widgets/TaskWidget';

// import MessageParser from './MessageParser';
// import ActionProvider from './ActionProvider';

export interface WithId {
  id: string;
}

interface BuildingActionsProps {
  projectId: string;
  buildingId: number;
  onClickActionItem(obj: WithId): void;
}

const BuildingActions = ({
  projectId,
  buildingId,
  onClickActionItem,
}: BuildingActionsProps) => {
  const sessionId = useMemo(() => {
    return Math.random().toString(36).substring(7);
  }, []);

  // const { userData } = useAuth();

  return (
    <div className="flex h-full flex-col justify-end">      
      <Typography>Building Workflows</Typography>
      <hr />
      <div className="py-16">
        <Stack spacing={4}>
          <WorkflowsProvider projectId={projectId} />
          </Stack>
        </div>
    </div>
  );
};

export default BuildingActions;
